
import { defineComponent } from "vue";

export default defineComponent({
  name: "button",
  props: {
    name: String,
  },
});
